import { type ReactNode } from 'react';
import injectSheet, { type WithStylesProps } from 'react-jss';

import { IconButton } from '~/eds/src/components/IconButton/IconButton';

import styles from './EcModalCard.styles';

interface EcModalCardProps extends WithStylesProps<typeof styles> {
  content: ReactNode;
  footer?: ReactNode;
  hideModal: () => void;
  id?: string;
  title: ReactNode;
  renderTitleControls?: () => ReactNode;
}

function EcModalCard({
  classes,
  content,
  footer,
  hideModal,
  id,
  title,
  renderTitleControls,
}: EcModalCardProps) {
  return (
    <div
      className={classes.ecModalCardWrapper}
      aria-label={title as string}
      id={id}
    >
      <div className={classes.ecModalCardTitleWrapper}>
        <div className={classes.ecModalCardTitle}>{title}</div>
        <div className={classes.ecModalCardTitleControl}>
          {renderTitleControls?.()}
          <IconButton
            icon="x"
            text={`${title} heading level 2 dialog close`}
            onClick={hideModal}
            tooltip="Close"
          />
        </div>
      </div>
      <div className={classes.ecModalCardContent}>{content}</div>
      {footer && <div className={classes.ecModalCardFooter}>{footer}</div>}
    </div>
  );
}

export default injectSheet(styles)(EcModalCard);
